"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _d3Dispatch = require("d3-dispatch"); // adds events to the supplied object


var DISPATCHERS = Symbol('dispatchers');

function _default(object) {
  if (!object[DISPATCHERS]) {
    object[DISPATCHERS] = {};
  }

  var dispatchersByEventName = object[DISPATCHERS];

  function eventName(type) {
    return type.split('.').shift();
  }

  object.on = function (type, handler) {
    var name = eventName(type);

    if (!dispatchersByEventName[name]) {
      dispatchersByEventName[name] = (0, _d3Dispatch.dispatch)(name);
    }

    dispatchersByEventName[name].on(type, handler);
    return object;
  };

  object.fire = function (type) {
    var dispatcher = dispatchersByEventName[eventName(type)];

    if (dispatcher) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      dispatcher.call.apply(dispatcher, [type, object].concat(args));
    }
  };
}